// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    [
      {
        "sub": "通信原理",
        "tec": "毛红艳",
        "week": "1-13周",
        "add": "教学楼B座119自控"
      },
      {
        "sub": "劳动与创造",
        "tec": "党元一",
        "week": "14周",
        "add": "实训楼F座203自控"
      }
    ],
    [
      {
        "sub": "电磁场与电磁波",
        "tec": "党元一",
        "week": "1-8周",
        "add": "教学楼B座119自控"
      },
      {
        "sub": "劳动与创造",
        "tec": "党元一",
        "week": "14周",
        "add": "实训楼F座203自控"
      }
    ],
    {
      "sub": "毛泽东思想和中国特色社会主义理论体系概论",
      "tec": "董海浪",
      "week": "1-8周",
      "add": "图书馆1楼党史+网络数字教育基地"
    },
    {
      "sub": "国家安全教育",
      "tec": "李健",
      "week": "9-12周",
      "add": "教学楼C座114教务"
    },
    0
  ],
  "2": [
    [
      {
        "sub": "数字信号处理",
        "tec": "王永博",
        "week": "1-6,9-10周",
        "add": "实训楼F座101自控"
      },
      {
        "sub": "劳动与创造",
        "tec": "党元一",
        "week": "14周",
        "add": "实训楼F座203自控"
      }
    ],
    [
      {
        "sub": "单片机原理与应用",
        "tec": "王德君",
        "week": "1-10周",
        "add": "实训楼F座203自控"
      },
      {
        "sub": "劳动与创造",
        "tec": "党元一",
        "week": "14周",
        "add": "实训楼F座203自控"
      }
    ],
    {
      "sub": "计算机网络",
      "tec": "张小瑞",
      "week": "1-12周",
      "add": "实训楼F座301信息"
    },
    0,
    0
  ],
  "3": [
    {
      "sub": "电磁场与电磁波",
      "tec": "党元一",
      "week": "1-8周",
      "add": "教学楼B座120自控"
    },
    [
      {
        "sub": "通信原理",
        "tec": "毛红艳",
        "week": "1-6周",
        "add": "教学楼B座120自控"
      },
      {
        "sub": "国家安全教育",
        "tec": "李健",
        "week": "9-12周",
        "add": "教学楼C座115教务"
      }
    ],
    0,
    0,
    {
      "sub": "就业创业指导",
      "tec": "邓苏栩包妍",
      "week": "1-5周",
      "add": "教学楼C座110教务"
    }
  ],
  "4": [
    {
      "sub": "单片机原理与应用",
      "tec": "王德君",
      "week": "1-10周",
      "add": "教学楼B座121自控"
    },
    {
      "sub": "数字信号处理",
      "tec": "王永博",
      "week": "1-6,9-10周",
      "add": "教学楼B座121自控"
    },
    {
      "sub": "毛泽东思想和中国特色社会主义理论体系概论",
      "tec": "董海浪",
      "week": "1-8周",
      "add": "图书馆1楼党史+网络数字教育基地"
    },
    0,
    0
  ],
  "5": [
    {
      "sub": "计算机网络",
      "tec": "张小瑞",
      "week": "1-12周",
      "add": "实训楼F座102自控"
    },
    {
      "sub": "通信原理",
      "tec": "毛红艳",
      "week": "1-13周",
      "add": "实训楼F座203自控"
    },
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
